import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FormControlLabel, Radio, RadioGroup } from '@mui/material';
import { Modal, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment-jalaali';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons';
import { api } from '../services';
import DOMPurify from 'dompurify';

export const Survey = () => {
  const [formData, setFormData] = useState({
    age: null,
    diabetes: null,
    cornealHump: null,
    rheumatism: null,
    pregnant: null,
    weight: '',
  });

  const [birthDate, setBirthDate] = useState({
    year: '',
    month: '',
    day: '',
  });
  const [calculatedAge, setCalculatedAge] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const navigate = useNavigate();
  const [submitState, setSubmitState] = useState(true);
  const [catDesc,setCatDesc] = useState("");
  const [cat,setCat] = useState("");
  const [searchParams] = useSearchParams();
  const CategoryID = searchParams.get('CategoryID');

  // لیست سال‌ها (از ۱۳۰۰ تا ۱۴۰۴)
  const years = Array.from({ length: 1404 - 1300 + 1 }, (_, i) => 1404 - i);

  // لیست ماه‌ها
  const months = [
    { value: 1, label: 'فروردین' },
    { value: 2, label: 'اردیبهشت' },
    { value: 3, label: 'خرداد' },
    { value: 4, label: 'تیر' },
    { value: 5, label: 'مرداد' },
    { value: 6, label: 'شهریور' },
    { value: 7, label: 'مهر' },
    { value: 8, label: 'آبان' },
    { value: 9, label: 'آذر' },
    { value: 10, label: 'دی' },
    { value: 11, label: 'بهمن' },
    { value: 12, label: 'اسفند' },
  ];

  // تابع بررسی سال کبیسه
  const isJalaliLeapYear = (year) => {
    if (!year) return false;
    const mod = year % 33;
    return [1, 5, 9, 13, 17, 22, 26, 30].includes(mod);
  };

  // تنظیم تعداد روزهای ماه
  const getDaysInMonth = (month, year) => {
    if (!month) return [];
    const monthNum = parseInt(month);
    if (monthNum >= 1 && monthNum <= 6) {
      return Array.from({ length: 31 }, (_, i) => i + 1);
    } else if (monthNum >= 7 && monthNum <= 11) {
      return Array.from({ length: 30 }, (_, i) => i + 1);
    } else if (monthNum === 12) {
      return Array.from({ length: isJalaliLeapYear(year) ? 30 : 29 }, (_, i) => i + 1);
    }
    return [];
  };

  // لیست روزها بر اساس ماه و سال
  const days = getDaysInMonth(birthDate.month, birthDate.year);

  // مدیریت تغییرات در select
  const handleDateChange = (event) => {
    const { name, value } = event.target;
    setBirthDate((prev) => {
      const newState = {
        ...prev,
        [name]: value,
      };
      if (name === 'month' || name === 'year') {
        newState.day = '';
      } else if (name === 'day') {
        const validDays = getDaysInMonth(prev.month, prev.year);
        if (!validDays.includes(parseInt(value))) {
          newState.day = '';
        }
      }
      return newState;
    });
  };

  // مدیریت تغییرات فرم
  const handleFromChange = (event) => {
    const { name, value } = event.target;
    if (name === 'cornealHump') {
      if (value === '') {
        navigate('/');
        return;
      }
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // بررسی خطاها و به‌روزرسانی submitState
  useEffect(() => {
    const { cornealHump } = formData;
    const hasErrors = cornealHump !== '1';
    setSubmitState(hasErrors);
  }, [formData]);

  // محاسبه سن با moment-jalaali
const calculateAge = (jalaliDate) => {
    try {
      const birthMoment = moment(jalaliDate, 'jYYYY/jMM/jDD');
      const currentMoment = moment();
      const age = currentMoment.diff(birthMoment, 'years');
      console.log('Calculated age:', age);
      return age >= 0 ? age : null;
    } catch (error) {
      console.error('Error calculating age:', error);
      return null;
    }
  };

  // محاسبه سن هنگام تغییر تاریخ
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await api.get('home/ShowDoctorCategory?OID=1');
        let data = response.data;
        if (typeof data === 'string') {
          try {
            data = JSON.parse(data);
          } catch (error) {
            console.error('Invalid JSON string:', data);
            return;
          }
        }
        // مرتب‌سازی بر اساس SortOrder
        const sortedData = data.sort((a, b) => a.SortOrder - b.SortOrder);
        // فیلتر کردن بر اساس CategoryId
        const filteredData = sortedData.filter(
          (category) => category.ServiceCategoryID === parseInt(CategoryID)
        );
        setCatDesc(filteredData[0].Description);
        setCat(filteredData[0]);
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
    
    const { year, month, day } = birthDate;
    if (year && month && day) {
      const jalaliDate = `${year}/${month.padStart(2, '0')}/${day.padStart(2, '0')}`;
      console.log('jalaliDate:', jalaliDate);
      const age = calculateAge(jalaliDate);
      setCalculatedAge(age);
      setFormData((prevData) => ({
        ...prevData,
        age: age,
      }));
    } else {
      setCalculatedAge(null);
      setFormData((prevData) => ({
        ...prevData,
        age: null,
      }));
    }
  }, [birthDate, CategoryID]);

  const handelSubmidt = () => {
    if (!submitState) {
      navigate(`/doctorlist?OID=1&CategoryID=${cat.ServiceCategoryID}&CategoryName=${cat.ServiceCategoryName}`);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalMessage('');
  };

  return (
    <>
      <section className="container mb-5 mt-xl-0 mt-4">
        <div className="row mb-4 mt-2">
          <div className="col-lg-12 path">
            <ul>
              <li>
                <Link className="text-decoration-none" to="/">
                  صفحه اصلی
                </Link>
                <FontAwesomeIcon icon={faAngleLeft} className="mr-2" />
              </li>
              <li>
                <span>   نوبت عمل حذف عینک</span>
              </li>
            </ul>
          </div>
        </div>
        <br />

        <div className="card p-3 shadow rounded-3">
          <h5 className="text-right" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(catDesc) }}>
           
          </h5>
        </div>

        <div className="justify-content-center mt-2 p-0">
          <div className="row d-flex align-items-stretch">
            <div className="col-lg-6 h-100">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center h-100" style={{ overflow: 'visible' }}>
                <form className="d-flex flex-column" style={{ minHeight: '100%' }}>
                   {/* <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۱. لطفا تاریخ تولد خود را وارد کنید؟
                    </label>
                    <div className="d-flex justify-content-start align-items-center gap-2 pt-3">
                      <div className="d-flex flex-column align-items-center">
                        <label className="text-right mb-1">سال</label>
                        <select
                          name="year"
                          value={birthDate.year}
                          onChange={handleDateChange}
                          className="form-control w-25"
                          style={{ textAlign: 'right' }}
                        >
                          <option value="">انتخاب</option>
                          {years.map((year) => (
                            <option key={year} value={year}>
                              {year}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="d-flex flex-column align-items-center">
                        <label className="text-right mb-1">ماه</label>
                        <select
                          name="month"
                          value={birthDate.month}
                          onChange={handleDateChange}
                          className="form-control w-25"
                          style={{ textAlign: 'right' }}
                        >
                          <option value="">انتخاب</option>
                          {months.map((month) => (
                            <option key={month.value} value={month.value}>
                              {month.label}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="d-flex flex-column align-items-center">
                        <label className="text-right mb-1">روز</label>
                        <select
                          name="day"
                          value={birthDate.day}
                          onChange={handleDateChange}
                          className="form-control w-25"
                          style={{ textAlign: 'right' }}
                          disabled={!birthDate.month}
                        >
                          <option value="">انتخاب</option>
                          {days.map((day) => (
                            <option key={day} value={day}>
                              {day}
                            </option>
                          ))}
                        </select>
                      </div>
                      {birthDate.year && birthDate.month && birthDate.day && calculatedAge >= 0 && (
                        <label className="red font-weight-bold pt-4">
                          {calculatedAge} سال
                        </label>
                      )}
                    </div>
                  </div>

                  <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۲. آیا بیماری دیابت دارید؟
                    </label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="diabetes"
                      value={formData.diabetes}
                      onChange={handleFromChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="بله" />
                      <FormControlLabel value="" control={<Radio />} label="خیر" />
                    </RadioGroup>
                  </div>

                  <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۳. آیا بیماری قوز قرنیه دارید؟
                    </label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="cornealHump"
                      value={formData.cornealHump}
                      onChange={handleFromChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="بله" />
                      <FormControlLabel value="" control={<Radio />} label="خیر" />
                    </RadioGroup>
                  </div>

                  <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۴. آیا بیماری رماتیسم دارید؟
                    </label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="rheumatism"
                      value={formData.rheumatism}
                      onChange={handleFromChange}
                    >
                      <FormControlLabel value="1" control={<Radio />} label="بله" />
                      <FormControlLabel value="" control={<Radio />} label="خیر" />
                    </RadioGroup>
                  </div>

                  <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۵. وزن خود را وارد کنید.
                    </label>
                    <input
                      type="number"
                      className="form-control rounded-input my-3 w-50"
                      name="weight"
                      required
                      value={formData.weight}
                      onChange={handleFromChange}
                      style={{
                        borderRadius: '10px',
                        padding: '10px',
                        fontSize: '16px',
                        textAlign: 'left',
                      }}
                    />
                  </div>

                  <div className="form-group form-check text-right">
                    <label className="form-check-label mt-2">
                      ۶. آیا در دوران بارداری یا شیردهی هستید؟
                    </label>
                    <RadioGroup
                      row
                      aria-labelledby="demo-row-radio-buttons-group-label"
                      name="pregnant"
                      value={formData.pregnant}
                      onChange={handleFromChange}
                    >
                      <FormControlLabel
                        value="1"
                        className="font-family-custom"
                        control={<Radio />}
                        label="بله"
                      />
                      <FormControlLabel value="" control={<Radio />} label="خیر" />
                    </RadioGroup>
                  </div> */}
<div className="form-group form-check " style={{ fontFamily: 'IRANSans', fontSize: '12px' }}>
    <label className="form-check-label mt-2">
      <span className="warning-animation" style={{ color: 'red' }}>شرایط و قوانین</span>
    <br />
    <hr />
    <div style={{ textAlign: 'justify' , fontSize: '12px' , fontFamily: 'IRANSans' , direction: 'rtl' , justifyContent:'end' }}>
      <p>1. سن شخص باید بالای 21 سال باشد و دو هفته قبل از زمان ویزیت، لنز تماسی استفاده نکرده باشد.</p>
      <p>2.	جهت افراد بالای 40سال که فقط عینک نزدیک دارند (پیرچشمی) انتخاب کاندید عمل محدودیت زیادی دارد و این افراد بعد از معاینات اولیه راهنمایی میشوند. </p>
      <p>3. دیابت، روماتیسم یا بیماری خاص نداشته باشد.</p>
      <p>4. در دوران بارداری یا شیردهی نباشد (سه ماه بعد از پایان شیردهی معاینات امکان‌پذیر می‌باشد).</p>
      <p>5. امکان عمل برای بیماران قوز قرنیه با بررسی مدارک قبلی و افراد با سابقه خانوادگی قوز قرنیه بعد از معاینات اولیه مشخص می‌شود.</p>
      <p>6. بیمارستان افراد بالای ۱۱۰ کیلوگرم را به دلیل خطای دستگاه جهت عمل پذیرش نمی‌کند.</p>
      <p> اینجانب بعد از مطالعه شرایط فوق، متقاضی گرفتن نوبت معاینه حذف عینک هستم.</p>
    </div>
  </label>

  <RadioGroup
    row
    className="custom-radio-group"
    aria-labelledby="demo-row-radio-buttons-group-label"
    name="cornealHump"
    value={formData.cornealHump}
    onChange={handleFromChange}
    
  >
    <FormControlLabel value="1" control={<Radio />} label="تایید می نمایم!" />
  </RadioGroup>
</div>

                  <button
                    onClick={handelSubmidt}
                    className="btn btn-primary btn-nobat mt-auto "
                    disabled={submitState}
                    style={{
                      backgroundColor: '#0db2ba',
                      width: 'auto',
                      margin: '0 auto',
                      display: 'block',
                      padding: '13px 40px',
                      fontSize: '14px',
                      borderRadius: '4px',
                      border: 'none',
                      boxShadow: 'none'
                    }}
                  >
                    ارسال
                  </button>
                </form>
              </div>
            </div>
            <div className="col-lg-6 m-auto h-100">
              <div className="card-body card p-3 shadow rounded-3 p-4 text-center h-100" style={{height: '630px', overflow: 'visible' }}>
                <img
                  src="/online-medical.png"
                  style={{ maxHeight: '630x'}}
                  className="img-fluid p-2 d-lg-block d-none"
                  alt="Online Medical"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal show={showModal} onHide={handleCloseModal} centered dir="rtl">
        <Modal.Header closeButton className="w-100">
          <Modal.Title className="text-right w-100">خطا</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p className="text-right">{modalMessage}</p>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-center">
          <Button variant="primary" onClick={handleCloseModal}>
            بستن
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Survey;


  

